/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_CriticalInputs */



/**
* | output |
* | --- |
* | "Critical" |
*
* @param {Manual_Qc_Priority_CriticalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_critical = /** @type {((inputs?: Manual_Qc_Priority_CriticalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_CriticalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Critique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kritisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Critico")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Критический")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crítico")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("批判的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("致命的")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गंभीर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crítico")
	return /** @type {LocalizedString} */ ("Critical")
});